module.exports = __webpack_public_path__ + "static/media/mission-vision_top_min.85f730d4.jpg";